export default {
    profile: 'Perfil',
    experiences: 'Experiencias',
    social: 'Redes Sociales',
    multimedia: 'Multimedia'
}